// extracted by mini-css-extract-plugin
module.exports = {"button":"style_button__1FwRL","button--outlined":"style_button--outlined__2u1mI","button--contained":"style_button--contained__3MdLc","icon-button":"style_icon-button__3XLCZ"};